var _circle, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 194,
    viewBox: "0 0 194 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 97,
    fill: "#2165A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5897 115C89.7617 115 88.9697 114.658 88.4027 114.055L73.8137 98.518C72.6767 97.312 72.7397 95.413 73.9457 94.279C75.1547 93.145 77.0537 93.205 78.1847 94.411L90.5597 107.584L115.784 79.978C116.906 78.751 118.802 78.67 120.026 79.786C121.247 80.902 121.331 82.801 120.215 84.022L92.8037 114.022C92.2427 114.64 91.4447 114.994 90.6107 115H90.5897Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_644_3900",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 79,
    width: 49,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5897 115C89.7617 115 88.9697 114.658 88.4027 114.055L73.8137 98.518C72.6767 97.312 72.7397 95.413 73.9457 94.279C75.1547 93.145 77.0537 93.205 78.1847 94.411L90.5597 107.584L115.784 79.978C116.906 78.751 118.802 78.67 120.026 79.786C121.247 80.902 121.331 82.801 120.215 84.022L92.8037 114.022C92.2427 114.64 91.4447 114.994 90.6107 115H90.5897Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_644_3900)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/Done.d0b7219bbda7618e15cf0f16fb6c2819.svg";
export { ForwardRef as ReactComponent };